import { FC } from 'react'
import { SelectChangeEvent } from '@mui/material'
import TrendsChartSelectField from 'ui/pages/cpi-details/sections/trends-tab/components/TrendsChartSelectField'

interface Props {
  label: string
  value: string
  options: string[]
  optionLabel?: (option: string) => string
  onChange: (value: string) => void
  ariaLabel: string
}

/**
 * The trends page owns how this control looks; this only bridges our value/label pairs onto its
 * string-only API, since our options carry wire values the user never sees.
 */
const InlineSelect: FC<Props> = ({ label, value, options, optionLabel, onChange, ariaLabel }) => {
  const renderOption = optionLabel ?? ((option: string) => option)

  return (
    <TrendsChartSelectField
      options={options.map(renderOption)}
      value={renderOption(value)}
      handleChange={(event: SelectChangeEvent<string>) => {
        const picked = options.find((option) => renderOption(option) === event.target.value)

        if (picked !== undefined) onChange(picked)
      }}
      label=""
      labeltext={label}
      placeholder={label}
      inlineLabel={label}
      disabled={false}
      hideSelected
      inputProps={{ 'aria-label': ariaLabel }}
    />
  )
}

export default InlineSelect
